module.exports = __webpack_public_path__ + "img/Number-of-Reviews-of-Top-100-Restaurants-300x300.aef669f9.jpg";